import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#1a1a1a] text-gray-400 pb-16 lg:pb-0">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <img src="https://storage.readdy-site.link/project_files/5c942cfb-1ccb-4a1f-ae9b-6223a6645081/db57ada8-027e-48ac-9357-a295d5e6a211_wazi_stories_transparent.png?v=b6e6edf7454a9eb40d503dba8ed8f73a" alt="Wazi Stories Afrique" className="h-12 w-auto object-contain mb-4" />
            <p className="text-sm leading-relaxed mb-2 text-gray-300 font-medium italic">&ldquo;{t("footer.tagline")}&rdquo;</p>
            <p className="text-xs text-gray-500 leading-relaxed mb-5">{t("footer.desc")}</p>
            <div className="flex gap-3">
              {[
                { icon: "ri-facebook-line", href: "#" },
                { icon: "ri-twitter-x-line", href: "#" },
                { icon: "ri-instagram-line", href: "#" },
                { icon: "ri-linkedin-line", href: "#" },
                { icon: "ri-whatsapp-line", href: "#" },
                { icon: "ri-youtube-line", href: "#" },
              ].map((s) => (
                <a key={s.icon} href={s.href} rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-orange-500 hover:text-white transition-colors cursor-pointer">
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Explorer */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">{t("footer.explore")}</h4>
            <ul className="space-y-3 text-sm">
              {[
                { labelKey: "footer.links.successStories", path: "/success-stories" },
                { labelKey: "footer.links.startups", path: "/startups" },
                { labelKey: "footer.links.innovations", path: "/innovations" },
                { labelKey: "footer.links.femmes", path: "/femmes-entrepreneures" },
                { labelKey: "footer.links.jeunesTalents", path: "/jeunes-talents" },
                { labelKey: "footer.links.diaspora", path: "/diaspora-africaine" },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="hover:text-orange-400 transition-colors cursor-pointer">{t(l.labelKey)}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Ressources */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">{t("footer.resources")}</h4>
            <ul className="space-y-3 text-sm">
              {[
                { labelKey: "footer.links.interviews", path: "/interviews", icon: "ri-play-circle-line", accent: true },
                { labelKey: "footer.links.opportunites", path: "/opportunites", icon: "ri-compass-3-line", accent: true },
                { labelKey: "footer.links.formations", path: "/formations", icon: "ri-graduation-cap-line", accent: true },
                { labelKey: "footer.links.recherche", path: "/recherche", icon: "ri-search-line" },
                { labelKey: "footer.links.soumettre", path: "/soumettre", icon: "ri-add-circle-line" },
                { labelKey: "footer.links.apropos", path: "/a-propos", icon: "ri-information-line" },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className={`flex items-center gap-2 hover:text-orange-400 transition-colors cursor-pointer ${l.accent ? "text-gray-300" : ""}`}>
                    <i className={`${l.icon} text-orange-400 text-xs`}></i>
                    {t(l.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">{t("footer.contact")}</h4>
            <ul className="space-y-3 text-sm mb-6">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-orange-400"></i> contact@waziconsulting.com</li>
              <li className="flex items-center gap-2"><i className="ri-whatsapp-line text-green-400"></i> WhatsApp Business</li>
              <li className="flex items-center gap-2"><i className="ri-map-pin-line text-orange-400"></i> Abidjan, C&ocirc;te d&apos;Ivoire</li>
            </ul>
            <div className="bg-gray-800 rounded-xl p-4 border border-gray-700">
              <p className="text-xs text-gray-400 mb-2 font-semibold">{t("footer.partners")}</p>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs bg-gray-700 text-gray-300 px-2 py-1 rounded-full">Salesforce</span>
                <span className="text-xs bg-gray-700 text-gray-300 px-2 py-1 rounded-full">Odoo</span>
                <span className="text-xs bg-orange-500/20 text-orange-400 px-2 py-1 rounded-full font-semibold">Wazi Bootcamp</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Disclaimer agrégateur */}
      <div className="border-t border-gray-800">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-5">
          <div className="flex items-start gap-3 bg-gray-800/50 border border-gray-700 rounded-xl px-5 py-4 mb-5">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-orange-400 text-lg"></i>
            </div>
            <p className="text-xs text-gray-400 leading-relaxed">
              <span className="text-orange-400 font-semibold">Wazi Stories est un agrégateur de contenus.</span>{" "}
              Les articles, interviews et portraits publiés sur cette plateforme sont sourcés depuis des médias, blogs et plateformes tiers reconnus à travers l&apos;Afrique et la diaspora.
              Wazi Stories ne revendique pas la paternité des contenus originaux et s&apos;efforce de toujours citer et rediriger vers la source d&apos;origine.
              Si vous êtes auteur ou éditeur et souhaitez signaler un contenu, contactez-nous à{" "}
              <a href="mailto:contact@waziconsulting.com" className="text-orange-400 hover:underline cursor-pointer">contact@waziconsulting.com</a>.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-600">
            <span>{t("footer.copyright")}</span>
            <div className="flex items-center gap-4">
              <Link to="/mentions-legales" className="hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap">
                Mentions légales
              </Link>
              <span className="w-1 h-1 rounded-full bg-gray-700"></span>
              <span className="text-orange-500 font-medium italic">{t("footer.motto")}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
